import React from 'react'

export interface Props {
  children?: React.ReactNode
}

export const Footer = (props: Props) => {
  const {children} = props
  return (
    <tfoot>
      <tr>{children}</tr>
    </tfoot>
  )
}
